"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { getBreadcrumbItems } from "@/lib/navigation/breadcrumb";

/**
 * Presentational shell: SSR provides initialItems in the first HTML paint.
 * Updates only when the pathname changes via client-side navigation
 * (root layout Server Components are not re-fetched on soft navigations).
 */
export default function BreadcrumbClient({ initialPathname, initialItems }) {
  const pathname = usePathname();
  const [items, setItems] = useState(initialItems ?? null);

  useEffect(() => {
    let cancelled = false;

    getBreadcrumbItems(pathname)
      .then((nextItems) => {
        if (!cancelled) setItems(nextItems);
      })
      .catch(() => {
        if (!cancelled) setItems(null);
      });

    return () => {
      cancelled = true;
    };
  }, [pathname]);

  if (!items?.length) return null;

  return (
    <nav aria-label="مسیر ناوبری" className="block container-base lg:container-xl mx-auto px-4 pb-4 sm:pb-6 lg:px-0">
      <ol
        className="flex items-center gap-1.5 overflow-x-auto pb-1 text-xs leading-relaxed text-mute scrollbar-hide sm:gap-2 sm:text-sm"
        dir="rtl"
      >
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${item.href}-${i}`} className="flex shrink-0 items-center gap-1.5 sm:gap-2">
              {i > 0 && <span className="text-white/20">/</span>}
              {isLast ? (
                <span className="max-w-[180px] truncate text-white-body sm:max-w-none">{item.label}</span>
              ) : (
                <Link
                  href={item.href}
                  className="whitespace-nowrap font-normal transition-colors hover:text-white"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
